/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component} from '@angular/core';
import {PagePermissionType} from "../../models/page-permission-type";
import {PagePermissionService} from "../../services/page-permission.service";

@Component({
    templateUrl: './infrastructure.component.html'
})
export class InfrastructureComponent {
  pagePermissionType = PagePermissionType;

  constructor(
    public pagePermissionService: PagePermissionService
  ) { }


}
